/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useCallback, useEffect } from 'react'
import {
	Stack,
	Text,
	Box,
	Flex,
	Heading,
	Image,
	chakra,
	Progress,
} from '@chakra-ui/react'
import {
	useLoadOrganizationList,
	useLoadOrganizationActiveDirectoryList,
} from '../../hooks/asset.hooks'
import { setLocalAuthDetails } from '../../utils/common.util'
import { useHistory } from 'react-router'
import OrganizationCard from './organization-card'
import { useOrganizationContext } from './../../context/organization.context'
import { organizationConst } from '../../utils/action.constant'
import { useLoadS3Creds } from './../../hooks/shared.hooks'

import { AUTH_LOGIN_MODE } from './../../utils/constant'
import { LS_LOGIN_MODE } from './login.util'
import SVGIcon from '../../assets/svgIcons'

export default function OrganizationListView({ props }) {
	const { mutate, isLoading: isLoadingOrgList } = useLoadOrganizationList()
	const { mutate: mutateActiveDirectory, isLoading: loadingActiveDirectory } =
		useLoadOrganizationActiveDirectoryList()
	const history = useHistory()
	const { dispatch } = useOrganizationContext()

	const { mutate: mutateS3Creds, isLoading: isLoadingS3Creds } =
		useLoadS3Creds()

	const [orgnizationList, setOrgnizationList] = useState([])

	useEffect(() => {
		setOrgList()
	}, [])

	const setOrgList = () => {
		let loginMode = Number(sessionStorage.getItem(AUTH_LOGIN_MODE))
		if (loginMode === LS_LOGIN_MODE.ACTIVE_DIRECTORY) {
			mutateActiveDirectory(
				{},
				{
					onSuccess: async res => {
						const {
							data: { status, response },
						} = res
						if (status === 200) {
							setLocalAuthDetails(response[0])
							getS3Creds(response)
						}
					},
				}
			)
		} else {
			mutate(
				{},
				{
					onSuccess: res => {
						const {
							data: { status, response },
						} = res
						if (status === 200) {
							setLocalAuthDetails(response[0])
							getS3Creds(response)
						}
					},
				}
			)
		}
	}

	const getS3Creds = response => {
		mutateS3Creds(
			{},
			{
				onSuccess: () => {
					dispatch({
						type: organizationConst.SET_ALL_ORGS_COLOR,
						payload: response,
					})
					setOrgnizationList(response)
				},
			}
		)
	}

	const navigateTo = org => {
		setLocalAuthDetails(org)
		history.push('/idcardscreen')
	}

	if (isLoadingOrgList || loadingActiveDirectory || isLoadingS3Creds) {
		return (
			<Stack
				mt='6.75rem'
				justifyContent='center'
				alignItems='center'
				direction='column'
			>
				<Text color='brand.800' fontSize='1rem'>
					Loading ...
				</Text>
				<Progress
					borderRadius='50px'
					isAnimated
					hasStripe
					colorScheme='green'
					width='20rem'
					bg='rgba(0, 0, 0, 0.25)'
					value={isLoadingOrgList ? '30' : '90'}
				/>
			</Stack>
		)
	}

	return (
		<>
			<Flex flexDirection='column'>
				<Box boxShadow='0px 2px 2px rgba(0, 0, 0, 0.1)' bg='brand.700'>
					<Box m={4} ml={8}>
						<SVGIcon
							iconName='NavbarGreneLogoSvg'
							svgProps={{
								width: '38',
								height: '36',
								viewBox: '0 0 38 36',
							}}
						/>
					</Box>
				</Box>
				<Box mt='5.6rem' mb='2.625rem' ml='auto' mr='auto'>
					<Box m={4} ml={8} mr={1} display='inline-block'>
						<SVGIcon
							iconName='GreenLogoLineSvg'
							svgProps={{
								width: '36',
								height: '10',
								viewBox: '0 0 36 10',
							}}
						/>
					</Box>

					<Heading
						as='h1'
						fontWeight='500'
						fontSize='1.5rem'
						display='inline-block'
						ml='2rem'
					>
						{'Please select the organization '}
					</Heading>
					<chakra.span color='gray.400'>
						&nbsp;(Tap on cards to select the organization)
					</chakra.span>
				</Box>
				<Box overflowX='auto' pl='20px'>
					<Flex>
						{(orgnizationList || []).map(org => (
							<OrganizationCard
								cardInfo={org}
								onSelect={navigateTo}
								key={org.organization_id}
							/>
						))}
					</Flex>
				</Box>
			</Flex>
		</>
	)
}
